import { CommonValue } from "./CommonValue";

class GenitalHerpes extends CommonValue {
    public IsSpouse: boolean;

    constructor(fields?: Partial<GenitalHerpes>) {
        super(fields);
        Object.assign(this, fields);
    }
}

export { GenitalHerpes };
